<script lang="ts">
  import {user} from '@/store';

  export let reencode: boolean = $user?.preferences?.resync || false;

  async function toggleResync() {
    reencode = !$user?.preferences?.resync;
    const payload = {
      resync: reencode
    };

    await user.updatePreferences(payload);
  }
</script>

<div
  class="mt-2 flex flex-col space-y-2 rounded-lg border border-gray-300 bg-gray-50 px-4 py-2 text-gray-700 dark:border-zinc-600 dark:bg-zinc-800 dark:text-zinc-200"
>
  <label for="resync-option" class="flex w-full cursor-pointer items-center gap-1">
    <span class="cursor-pointer py-4 pt-3 text-start text-sm font-medium text-gray-700">Resync Video</span>
    <!-- <i use:tooltip={"If the video you're reuploading had audio syncing issues, press this to resync them."} class="text-black fa-regular fa-circle-question text-xs"></i> -->
    <div class="relative ml-auto">
      <input
        bind:checked={reencode}
        on:change={() => toggleResync()}
        id="resync-option"
        type="checkbox"
        class="peer sr-only"
      />
      <div
        class="block h-8 w-14 rounded-full bg-zinc-300 transition-all peer-checked:!bg-primary dark:bg-zinc-800"
      ></div>
      <div
        class="dot absolute left-1 top-1 !h-6 !w-6 rounded-full !bg-zinc-100 bg-white transition peer-checked:translate-x-full dark:!bg-zinc-700"
      ></div>
    </div>
  </label>
  <div class="py-2">
    <p class="text-justify text-sm text-gray-700">
      <span class="font-bold text-gray-900"><i class="fa-regular fa-circle-info"></i></span> Turn this on if your clips had
      audio-video sync or compiling/buffering issues. Your previous selection will be applied the next time you upload from
      a file.
    </p>
  </div>
</div>
